import React from 'react';
import { Table } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { states } from '@/constants/lifecycle';
import CompactTableHeader from '@/components/table/CompactTableHeader';
import DictionaryReportsTableColumns from './DictionaryReportsTableColumns';

const DictionaryReportsTableHeader = ({ columns, readStatus, reportType }) => (
  <Table.Header className="aridhia-dictionary-reports-table-header" fullWidth>
    <CompactTableHeader
      className="aridhia-dictionary-reports-header"
      headerId={`dataset.data.dictionary.${reportType}.reports`}
      description={`dataset.data.dictionary.${reportType}.reports.description`}
      isLoading={readStatus === states.PENDING}
      numberOfColumns={columns.length}
    >
      <span className="normal">
        <FormattedMessage id={`dataset.data.dictionary.${reportType}.reports.description`} />
      </span>
    </CompactTableHeader>
    <DictionaryReportsTableColumns columns={columns} />
  </Table.Header>
);

export default DictionaryReportsTableHeader;
